import { Grid } from '@mantine/core';
import { Control, Controller } from 'react-hook-form';

import Dropdown from '@/ui/Dropdown';

import { alertColorTypeOptions, reportTypeOptions } from '../../ReportDetails';
import { ReportFormValues } from '../index'; // adjust the path if needed

const ReportMetaSection = ({ control }: { control: Control<ReportFormValues> }) => {
  return (
    <Grid>
      <Grid.Col span={4}>
        <Controller
          control={control}
          name="reportType"
          render={({ field }) => (
            <Dropdown
              label="Report Type"
              required
              labelVariant="regular"
              options={reportTypeOptions}
              value={reportTypeOptions.find((opt) => opt.value === field.value)}
              onChange={(option) => field.onChange(option?.value)}
              placeholder="Select Report Type"
            />
          )}
        />
      </Grid.Col>

      <Grid.Col span={4}>
        <Controller
          control={control}
          name="color"
          render={({ field }) => (
            <Dropdown
              label="Alert Type"
              required
              labelVariant="regular"
              options={alertColorTypeOptions}
              value={alertColorTypeOptions.find((opt) => opt.value === field.value)}
              onChange={(option) => field.onChange(option?.value)}
              placeholder="Select Alert Type"
            />
          )}
        />
      </Grid.Col>
    </Grid>
  );
};

export default ReportMetaSection;
